import { BigNumber, ethers } from "ethers";
import { getGlobalState, setGlobalState } from './store'
import Alert from 'sweetalert2'


import SPOTIZ_ABI from "./artifacts/src/contracts/SpotizCollection.sol/SpotizCollection.json";

  const log = console.log;
  const ethereum=window.ethereum;

  // sale price expressed in ETH
  const salePrice = ethers.utils.parseEther( (process.env.REACT_APP_NFT_SALE_PRICE || "0").toString());

  // maximum mintable items per transaction
  const maxMintPerTx = Number(process.env.REACT_APP_NFT_MAX_MINT_PER_TX) || 20 ;

  // maximum mintable items per users address
  const maxMintPerUsers = Number(process.env.REACT_APP_NFT_MAX_MINT_PER_USER) || 20;

  // Sale status, true to open sale or false to close sale.
  const saleStatus = (process.env.REACT_APP_NFT_SALE_STATUS=='true') || false;

  // Sale Type, true to open sale or false to close sale.
  const saleType = process.env.REACT_APP_NFT_SALE_TYPE || "Private";

  const getSpotizContract =  () => {

    if(ethereum){
      /** @dev CONTRACT INSTANCE **/
      const provider = new ethers.providers.Web3Provider(ethereum)
      const signer = provider.getSigner();

      // deployed Spotiz contract address
      const deployedSpotizContractAddress = process.env.REACT_APP_NFT_DEPLYOYED_CONTRACT_ADDRESS || "";

      // Spotiz contract instance
      const spotizContractInstance = new ethers.Contract(deployedSpotizContractAddress, SPOTIZ_ABI.abi, signer);
      return spotizContractInstance;
    }
    return null;
  }
  const spotizContract=getSpotizContract();
  
  const isExistMetaMask = () =>{
    if (!ethereum){
      Alert.fire({
        icon: 'info',
        title: "MetaMask not installed",
        html:"<p><a href='https://metamask.io/download/' target='_blank' class='link'><b>Click here</b></a> to install MetaMask.",
      });
      return false;
    }
    return true;
  }
  const accoutnUpdate = async (accounts) => {
    var userBalanceHex=0;
    if (accounts!=undefined && accounts.length) {
      
      //Throwing error so that's why added again try catch
      try{
        if(spotizContract!=null)
            userBalanceHex = (await spotizContract.balanceOfUser(accounts[0])).length;
      }  catch (error) {
        Alert.close();
        //log(error)
      }
       setGlobalState('connectedAccount', {account: accounts[0],balance:userBalanceHex})
    }else
      setGlobalState('connectedAccount', {account: '',balance:''});
  }
  const connectWallet = async () => {
    
    if(isExistMetaMask()){
      Alert.fire({
        title: 'Connecting...',
        html: 'Please wait we are requesting to MetaMask for connection.',
        didOpen: async ()  => {
          
          Alert.showLoading()
          
            const accounts = await ethereum.request({ method: 'eth_requestAccounts' }).catch(() => {
              //Alert.close();
            });
            if(accounts!=undefined){
              await accoutnUpdate(accounts).then(() => {
                Alert.fire({
                  icon:'success',
                  title: 'Connected',
                  timer: 2000,
                  timerProgressBar: true,
                  html: 'Your metamask wallet is connected.',
                });
              })
            }
          
        }
      })
    }
  }
  const disconnectWallet = async () => {
    //here im looking somfunction that can disconnect from metamask
    setGlobalState('connectedAccount', {account: '',balance:''})
  }

  //for check wallet is connected or not 
  const initWallet = async () => {
    try {
      
      if(isExistMetaMask() ){
         const accounts = await ethereum.request({ method: 'eth_accounts' })
          await accoutnUpdate(accounts)
       }
       return true;

    } catch (error) {
      reportError("",error)
    }
  }

  const handleEthEvents = () =>{
    
    ethereum.on('disconnect', () =>{
      
        setGlobalState('connectedAccount', {account: '',balance:''})
    });
    ethereum.on('accountsChanged', async (account) => {
      await initWallet()
    })

    ethereum.on('chainChanged', async (chainId) => {
      
        if(chainId!=1){
          Alert.fire({
            title: "Please change to ethereum mainnet. ",
            icon: 'error'
          });
          setGlobalState('connectedAccount', {account: '',balance:''})
          return false;
        }
        //If there different wallet then we needed to intialze again 
        await initWallet()
    })
   
  }
  //calling all etheriam events
  if(spotizContract!=null)
  handleEthEvents();
 
  
  const payToMint = async () => {
    
      if(saleStatus && isExistMetaMask()){

          // Mint some NFTs, This is an example please set proper value in production
          const amountToMint =  getGlobalState('nftCart')
          const connectedAccount = getGlobalState("connectedAccount");

          if(connectedAccount.account==""){
            reportError("Please connect your account by clicking on the Connect Account button on top right in the website.","") 
            return false;
          }
          else if(amountToMint>maxMintPerTx){     
              reportError("Max "+maxMintPerTx+" mint allow per trasaction.","")        
              return false;
          }
          else if((amountToMint+connectedAccount.balance) >maxMintPerUsers){
              reportError("Max "+maxMintPerUsers+" mint allow per user.","") 
              return false;
          }
          else{
            
            try {

                const ethAmountToSend = BigNumber.from(amountToMint).mul(salePrice);
                if(ethAmountToSend>0 && amountToMint>0){
                  const mintTx = await spotizContract.mintPublicSale(amountToMint, {value : ethAmountToSend});
                  await mintTx.wait()
                  
                  // Show user's balance
                  const  userBalanceHex = await spotizContract.balanceOfUser(connectedAccount.account);
                  setGlobalState('connectedAccount', {account:connectedAccount.account,balance:userBalanceHex.length})
                  return true;
                }
                return false;
              } catch (error) {
                reportError("",error)
                return false;
              }
            
          }
          
      }
      return false;
  }

  //handling error within a main function 
  const reportError = (message,error) => {
    //execute that error on main function 
    if(message=="")
      message="Something went wrong, please try again!";

    Alert.fire({
      html: "<b>"+message+"</b>",
      icon: 'error',
      timer: 4000,
      timerProgressBar: true,
    });
    if(error!="")
    throw new Error(error)
  }


  export { 
    initWallet, 
    payToMint,
    connectWallet,
    disconnectWallet,
    maxMintPerUsers,
    saleStatus,saleType
  }
  
  